module.exports = __webpack_public_path__ + "img/boosting-retention.350b5f89.svg";